// import React, { useState, useEffect, useMemo } from "react";
// import NewProductCard from "./NewProductCard";
// import { fetchProduct } from "../services/api";
// import PropTypes from "prop-types";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";

// const ProductCardSkeleton = () => (
//   <div className="animate-pulse p-4 border rounded-lg w-full">
//     <div className="bg-gray-200 h-40 rounded mb-3" />
//     <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
//     <div className="h-3 bg-gray-200 rounded w-1/2" />
//   </div>
// );

// const TopProducts = ({ 
//   productIds: propProductIds = [], 
//   taxonomy = "equipment-buy",
//   gridCols = {
//     sm: 2,
//     lg: 3,
//     xl: 4
//   }
// }) => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const productIds = useMemo(
//     () => propProductIds, 
//     [JSON.stringify(propProductIds)]
//   );

//   // Generate grid classes based on gridCols prop
//   const gridClasses = useMemo(() => {
//     const classes = ['hidden', 'sm:grid', 'gap-6'];
    
//     if (gridCols.sm) classes.push(`grid-cols-${gridCols.sm}`);
//     if (gridCols.lg) classes.push(`lg:grid-cols-${gridCols.lg}`);
//     if (gridCols.xl) classes.push(`xl:grid-cols-${gridCols.xl}`);
    
//     return classes.join(' ');
//   }, [gridCols]);

//   useEffect(() => {
//     let mounted = true;

//     async function loadProducts() {
//       setLoading(true);
//       setError(null);

//       try {
//         const settled = await Promise.allSettled(
//           productIds.map((id) => fetchProduct(id))
//         );

//         const fulfilled = settled
//           .map((r, i) => {
//             if (r.status === "fulfilled") {
//               const product = r.value;
//               if (product && !Array.isArray(product.images)) {
//                 if (product.images && typeof product.images === 'object') {
//                   // If images is an object with src/url properties
//                   product.images = [product.images.src || product.images.url || ''];
//                 } else if (typeof product.images === 'string') {
//                   // If images is a string
//                   product.images = [product.images];
//                 } else {
//                   product.images = [];
//                 }
//               }
//               if (product && Array.isArray(product.images) && product.images.length > 0) {
//                 product.images = product.images.map(img => {
//                   if (typeof img === 'object' && img !== null) {
//                     return img.src || img.url || '';
//                   }
//                   return img;
//                 }).filter(Boolean);
//               }
              
//               return product;
//             }
//             console.warn(`Failed to fetch product ${productIds[i]}:`, r.reason);
//             return null;
//           })
//           .filter(Boolean);

//         if (!mounted) return;

//         if (fulfilled.length === 0) {
//           setError("No products could be loaded.");
//           setProducts([]);
//         } else {
//           console.log('Loaded products:', fulfilled); // Debug log
//           setProducts(fulfilled);
//         }
//       } catch (err) {
//         if (!mounted) return;
//         setError(err?.message || "Failed to load products");
//         setProducts([]);
//       } finally {
//         if (!mounted) return;
//         setLoading(false);
//       }
//     }

//     loadProducts();

//     return () => {
//       mounted = false;
//     };
//   }, [productIds]);

//   return (
//     <div className="top-products-component">
          
//       {loading && (
//         <div className={`recommended-products-grid grid grid-cols-1 ${gridClasses.replace('hidden sm:grid', 'sm:grid-cols-2 lg:grid-cols-4')}`}>
//           {Array.from({ length: productIds.length }).map((_, i) => (
//             <ProductCardSkeleton key={`skeleton-${i}`} />
//           ))}
//         </div>
//       )}

//       {error && !loading && (
//         <div className="text-center text-red-600 py-4" role="alert" aria-live="polite">
//           {error}
//         </div>
//       )}

//       {!loading && !error && products.length > 0 && (
//         <>
//           {/* Mobile slider (visible on small screens) */}
//           <div className="recommended-products-mobile-slider block sm:hidden">
//             <Swiper
//               modules={[Autoplay]}
//               spaceBetween={16}
//               slidesPerView={1.1}
//               autoplay={{ delay: 3000, disableOnInteraction: false }}
//               breakpoints={{
//                 480: {
//                   slidesPerView: 1.2,
//                   spaceBetween: 20
//                 }
//               }}
//             >
//               {products.map((product) => (
//                 <SwiperSlide key={product?.id ?? product?.handle ?? Math.random()}>
//                   <NewProductCard product={product} taxonomy={taxonomy} />
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>

//           {/* Desktop Grid (hidden on small screens) */}
//           <div className={`recommended-products-grid ${gridClasses}`}>
//             {products.map((product) => (
//               <NewProductCard 
//                 key={product?.id ?? product?.handle ?? Math.random()} 
//                 product={product} 
//                 taxonomy={taxonomy} 
//               />
//             ))}
//           </div>
//         </>
//       )}

//       <style jsx>{`
//         .top-products-component {
//           width: 100%;
//         }
//         /* FIX: Ensure Swiper doesn't hide overflow */
//         .recommended-products-mobile-slider :global(.swiper) {
//           overflow: visible !important;
//         }

//         .recommended-products-mobile-slider :global(.swiper-wrapper) {
//           display: flex;
//           align-items: stretch;
//         }

//         .recommended-products-mobile-slider :global(.swiper-slide) {
//           height: auto;
//           display: flex;
//         }

//         /* Ensure proper spacing and visibility */
//         .recommended-products-grid,
//         .recommended-products-mobile-slider {
//           margin: 0 auto;
//           padding: 1rem 0;
//         }
//       `}</style>
//     </div>
//   );
// };

// TopProducts.propTypes = {
//   productIds: PropTypes.arrayOf(PropTypes.string),
//   taxonomy: PropTypes.string,
//   gridCols: PropTypes.shape({
//     sm: PropTypes.number,
//     lg: PropTypes.number,
//     xl: PropTypes.number,
//   }),
// };

// export default TopProducts;


import React, { useState, useEffect, useMemo } from "react";
import NewProductCard from "./NewProductCard";
import { fetchProduct } from "../services/api";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const ProductCardSkeleton = () => (
  <div className="animate-pulse p-4 border rounded-lg w-full">
    <div className="bg-gray-200 h-40 rounded mb-3" />
    <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
    <div className="h-3 bg-gray-200 rounded w-1/2" />
  </div>
);

const TopProducts = ({ 
  productIds: propProductIds = [], 
  taxonomy = "equipment-buy",
  gridCols = {
    sm: 2,
    lg: 3,
    xl: 4
  }
}) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const productIds = useMemo(
    () => propProductIds, 
    [JSON.stringify(propProductIds)]
  );

  // Generate grid classes based on gridCols prop - FIXED VERSION
  const gridClasses = useMemo(() => {
    return [
      'hidden',
      'sm:grid',
      'gap-6',
      gridCols.sm && `sm:grid-cols-${gridCols.sm}`,
      gridCols.lg && `lg:grid-cols-${gridCols.lg}`,
      gridCols.xl && `xl:grid-cols-${gridCols.xl}`
    ].filter(Boolean).join(' ');
  }, [gridCols]);

  // Skeleton grid classes - FIXED VERSION
  const skeletonGridClasses = useMemo(() => {
    return [
      'grid',
      'grid-cols-1',
      'gap-6',
      gridCols.sm && `sm:grid-cols-${gridCols.sm}`,
      gridCols.lg && `lg:grid-cols-${gridCols.lg}`,
      gridCols.xl && `xl:grid-cols-${gridCols.xl}`
    ].filter(Boolean).join(' ');
  }, [gridCols]);

  useEffect(() => {
    let mounted = true;

    async function loadProducts() {
      setLoading(true);
      setError(null);

      try {
        const settled = await Promise.allSettled(
          productIds.map((id) => fetchProduct(id))
        );

        const fulfilled = settled
          .map((r, i) => {
            if (r.status === "fulfilled") {
              const product = r.value;
              if (product && !Array.isArray(product.images)) {
                if (product.images && typeof product.images === 'object') {
                  // If images is an object with src/url properties
                  product.images = [product.images.src || product.images.url || ''];
                } else if (typeof product.images === 'string') {
                  // If images is a string
                  product.images = [product.images];
                } else {
                  product.images = [];
                }
              }
              if (product && Array.isArray(product.images) && product.images.length > 0) {
                product.images = product.images.map(img => {
                  if (typeof img === 'object' && img !== null) {
                    return img.src || img.url || '';
                  }
                  return img;
                }).filter(Boolean);
              }
              
              return product;
            }
            console.warn(`Failed to fetch product ${productIds[i]}:`, r.reason);
            return null;
          })
          .filter(Boolean);

        if (!mounted) return;

        if (fulfilled.length === 0) {
          setError("No products could be loaded.");
          setProducts([]);
        } else {
          console.log('Loaded products:', fulfilled); // Debug log
          setProducts(fulfilled);
        }
      } catch (err) {
        if (!mounted) return;
        setError(err?.message || "Failed to load products");
        setProducts([]);
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    }

    loadProducts();

    return () => {
      mounted = false;
    };
  }, [productIds]);

  return (
    <div className="top-products-component">
          
      {loading && (
        <div className={`recommended-products-grid ${skeletonGridClasses}`}>
          {Array.from({ length: productIds.length }).map((_, i) => (
            <ProductCardSkeleton key={`skeleton-${i}`} />
          ))}
        </div>
      )}

      {error && !loading && (
        <div className="text-center text-red-600 py-4" role="alert" aria-live="polite">
          {error}
        </div>
      )}

      {!loading && !error && products.length > 0 && (
        <>
          {/* Mobile slider (visible on small screens) */}
          <div className="recommended-products-mobile-slider block sm:hidden">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={16}
              slidesPerView={1.1}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              breakpoints={{
                480: {
                  slidesPerView: 1.2,
                  spaceBetween: 20
                }
              }}
            >
              {products.map((product) => (
                <SwiperSlide key={product?.id ?? product?.handle ?? Math.random()}>
                  <NewProductCard product={product} taxonomy={taxonomy} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Desktop Grid (hidden on small screens) */}
          <div className={`recommended-products-grid ${gridClasses}`}>
            {products.map((product) => (
              <NewProductCard 
                key={product?.id ?? product?.handle ?? Math.random()} 
                product={product} 
                taxonomy={taxonomy} 
              />
            ))}
          </div>
        </>
      )}

      <style jsx>{`
        .top-products-component {
          width: 100%;
        }
        /* FIX: Ensure Swiper doesn't hide overflow */
        .recommended-products-mobile-slider .swiper {
          overflow-y: visible !important;
          overflow-x: visible !important;
        }

        .recommended-products-mobile-slider :global(.swiper-wrapper) {
          display: flex;
          align-items: stretch;
        }

        .recommended-products-mobile-slider .swiper-slide {
          height: auto;
          display: flex;
        }

        /* Ensure proper spacing and visibility */
        .recommended-products-grid,
        .recommended-products-mobile-slider {
          margin: 0 auto;
          padding: 1rem 0;
        }

        .recommended-products-mobile-slider{
          overflow: hidden;
          }
      `}</style>
    </div>
  );
};

TopProducts.propTypes = {
  productIds: PropTypes.arrayOf(PropTypes.string),
  taxonomy: PropTypes.string,
  gridCols: PropTypes.shape({
    sm: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
  }),
};

export default TopProducts;